import { PrefsProxy } from '@proxies/prefs'

export const TOOLBAR_MENU_COLUMNS_PREF = 'COLUMNAMENU'

export type ToolbarMenuColumns = 2 | 3

export const TOOLBAR_MENU_COLUMNS_INITIAL_FOR_P: ToolbarMenuColumns = 3

export function isTipoUsuarioP(tipoUsuario?: string | null): boolean {
  return tipoUsuario === 'P'
}

/** Tipo de usuario sin depender del store (evita imports circulares). */
export function getResolvedTipoUsuario(): string | null {
  if (typeof localStorage !== 'undefined') {
    if (localStorage.getItem('isUserLogged') !== 'true') {
      return 'P'
    }
    try {
      const raw = localStorage.getItem('userData')
      if (raw) {
        const data = JSON.parse(raw) as { tipoUsuario?: string }
        if (data.tipoUsuario) return data.tipoUsuario
      }
    } catch {
      // ignore
    }
  }
  if (typeof sessionStorage !== 'undefined') {
    const fromSession = sessionStorage.getItem('tipoUsuario')
    if (fromSession) return fromSession
  }
  return null
}

export function parseToolbarMenuColumns(value: unknown): ToolbarMenuColumns {
  if (value === 2 || value === '2') return 2
  if (value === 3 || value === '3') return 3
  const n = Number(value)
  return n === 2 ? 2 : 3
}

export function getToolbarMenuColumnsFromPrefs(
  prefs: Record<string, unknown> | undefined,
): ToolbarMenuColumns {
  return parseToolbarMenuColumns(prefs?.[TOOLBAR_MENU_COLUMNS_PREF])
}

/** Valor al cargar sesión: el que venga en prefs.COLUMNAMENU del backend (3 si falta). */
export function getInitialToolbarMenuColumns(
  prefs: Record<string, unknown> | undefined,
): ToolbarMenuColumns {
  return getToolbarMenuColumnsFromPrefs(prefs)
}

export function getToolbarMenuMinWidth(columns: ToolbarMenuColumns): string {
  return columns === 2 ? 'min-w-[23rem]' : 'min-w-[34rem]'
}

export function persistToolbarMenuColumns(
  columns: ToolbarMenuColumns,
  tipoUsuario?: string | null,
) {
  const tipo = tipoUsuario ?? getResolvedTipoUsuario()
  if (isTipoUsuarioP(tipo)) {
    return Promise.resolve()
  }
  return new PrefsProxy().updatePreference({
    nombre: TOOLBAR_MENU_COLUMNS_PREF,
    valor: columns,
  })
}
